import PlayButton from './PlayButton';
import useInView from '../../hooks/useInView';

const Hero = ({
  title = 'OASIS',
  backgroundImage = '/assets/imgs/Home/Hero Banner.png',
  showSocial = true,
  showPlay = true,
  heightClasses = 'h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[90vh] xl:h-screen',
  bgSize = 'cover',
  bgPosition = 'center center'
}) => {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const handlePlayClick = (e) => {
    e.preventDefault();
    console.log('Play button clicked');
  };

  return (
    <section 
      id="home" 
      ref={ref}
      className={`relative w-full ${heightClasses} flex items-center justify-center overflow-hidden mt-20`}
    >
      {/* Background Image with better responsive handling */}
      <div 
        className={`absolute inset-0 w-full h-full hero-bg-responsive transition-all duration-900 ease-out ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
        style={{
          backgroundImage: `url("${backgroundImage}")`,
          backgroundSize: bgSize,
          backgroundPosition: bgPosition
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-radial from-black/5 to-black/20"></div>

      {/* Center Title */}
      <div className="relative z-10 text-center px-4">
        <h1 className={`text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-normal text-cream tracking-wider uppercase drop-shadow-lg transform transition-all duration-900 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {title}
        </h1>
      </div>

      {/* Social Links - Left Side */}
      {showSocial && (
        <div className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 flex flex-col gap-8 md:gap-12">
          <a href="#" className="text-white/70 hover:text-white text-xs md:text-sm font-bold italic tracking-widest transition-all duration-300 [writing-mode:vertical-rl] rotate-180 hover:tracking-wider">
            facebook
          </a>
          <a href="#" className="text-white/70 hover:text-white text-xs md:text-sm font-bold italic tracking-widest transition-all duration-300 [writing-mode:vertical-rl] rotate-180 hover:tracking-wider">
            youtube
          </a>
          <a href="#" className="text-white/70 hover:text-white text-xs md:text-sm font-bold italic tracking-widest transition-all duration-300 [writing-mode:vertical-rl] rotate-180 hover:tracking-wider">
            instagram
          </a>
        </div>
      )}

      {/* Play Button - Bottom Right */}
      {showPlay && (
        <PlayButton onClick={handlePlayClick} className="absolute right-6 md:right-12 bottom-8 md:bottom-12 z-20" />
      )}
    </section>
  );
};

export default Hero;
